import { render, staticRenderFns } from "./MetadataView.vue?vue&type=template&id=d5e58a38&scoped=true"
import script from "./MetadataView.vue?vue&type=script&lang=js"
export * from "./MetadataView.vue?vue&type=script&lang=js"
import style0 from "./MetadataView.vue?vue&type=style&index=0&id=d5e58a38&prod&lang=css"
import style1 from "./MetadataView.vue?vue&type=style&index=1&id=d5e58a38&prod&scoped=true&lang=scss"
import style2 from "./MetadataView.vue?vue&type=style&index=2&id=d5e58a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e58a38",
  null
  
)

export default component.exports